"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
var _CustomIconOrImage = _interopRequireDefault(require("../../shared/CustomIconOrImage"));
var _useAppDispatch = require("../../../hooks/useAppDispatch");
var _recommendationActions = require("../../../store/recommendation/recommendationActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TopFeatures = _ref => {
  var _mainSpecs, _mainSpecs2, _mainSpecs5, _mainSpecs6, _mainSpecs7;
  let {
    handset,
    handsetIndex,
    onFullSpecsShow
  } = _ref;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  let {
    mainCharacteristics: mainSpecs,
    groupedCharacteristics: specs
  } = handset;
  mainSpecs = (_mainSpecs = mainSpecs) === null || _mainSpecs === void 0 ? void 0 : _mainSpecs.filter(s => !!s.valueText);
  if (!((_mainSpecs2 = mainSpecs) !== null && _mainSpecs2 !== void 0 && _mainSpecs2.length)) return null;
  const onSpecsHeaderToggle = state => {
    dispatch((0, _recommendationActions.setAreRecommendationSpecsVisible)(state));
  };
  const getMainSpecsRow = function () {
    var _mainSpecs3;
    let row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let itemsPerRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    const firstRowItem = row * itemsPerRow;
    const lastItemRow = row * itemsPerRow + itemsPerRow;
    return (_mainSpecs3 = mainSpecs) === null || _mainSpecs3 === void 0 ? void 0 : _mainSpecs3.slice(firstRowItem, lastItemRow).map(spec => /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'center'
      },
      key: spec.name
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      name: spec.iconName,
      group: "midLight",
      size: 2
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      columns: {
        sm: 1,
        md: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1
    }, _services.locale.localeString(`Specs.${spec.name}`), " "), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      text: _services.locale.localeString(`Specs.${spec.valueText}`, spec.valueText)
    }))));
  };
  const getMainSpecsRowsSm = () => {
    var _mainSpecs4;
    return (_mainSpecs4 = mainSpecs) === null || _mainSpecs4 === void 0 ? void 0 : _mainSpecs4.map(spec => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: spec.name
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      columns: {
        sm: 2
      },
      key: spec.name
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      name: spec.iconName || 'mobile',
      group: "midLight",
      size: 2
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString(`Specs.${spec.name}`))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      justify: "center",
      size: 3,
      weight: 3
    }, spec.valueText))));
  };
  const renderFullSpec = function (iconName, iconPosition) {
    let appearance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'primary';
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      justify: 'center'
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
      id: `recommendation-handset-button-full-specs-${handsetIndex}`,
      appearance: appearance,
      text: _services.locale.localeString('Recommendation.ShowFullSpecs'),
      icon: {
        name: iconName,
        justify: iconPosition
      },
      fullSize: true,
      size: 2,
      onClick: () => onFullSpecsShow(specs)
    }));
  };
  if (((_mainSpecs5 = mainSpecs) === null || _mainSpecs5 === void 0 ? void 0 : _mainSpecs5.length) === 0) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), /*#__PURE__*/_react.default.createElement("div", {
    id: `recommendation-handset-specs-${handsetIndex}`,
    className: "product-collapsible"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, {
    dataAttributes: {
      'data-test-id': 'specification-button'
    },
    onToggle: onSpecsHeaderToggle
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: 'list-view'
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    level: 5,
    text: _services.locale.localeString('Recommendation.HandsetSpecs')
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, ((_mainSpecs6 = mainSpecs) === null || _mainSpecs6 === void 0 ? void 0 : _mainSpecs6.length) > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      md: 3
    },
    spacing: 2
  }, getMainSpecsRow(0))), ((_mainSpecs7 = mainSpecs) === null || _mainSpecs7 === void 0 ? void 0 : _mainSpecs7.length) > 2 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      md: 3
    },
    spacing: 2
  }, getMainSpecsRow(1)))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, getMainSpecsRowsSm()), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), renderFullSpec('chevron-right', 'right')))));
};
var _default = TopFeatures;
exports.default = _default;